import React, { Component } from "react";
import { Fetch, downloadPDF } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import { Select, DatePicker, message, ConfigProvider, Modal } from "antd";
import Loader from "../../utils/loader";
import less from "./invoices.module.scss";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import moment from "moment";
import downloadIcon from "../../images/download.svg";
import remarkIcon from "../../images/remark.svg";
import remarkMobileIcon from "../../images/remark-mobile.svg";
import intraIcon from "../../images/intra.svg";
import editedIcon from "../../images/edited.svg";
import dayjs from "dayjs";
import jwt from "../../utils/jwt";

const { RangePicker } = DatePicker;
const { Option } = Select;

class buses extends Component {
  constructor(props) {
    super(props);
    this.decodedToken = null;
    this.state = {
      loading: true,
      tableLoader: false,
      selectedKey: null,
      isMobile: false,
      showSideMenu: false,
      showManageInvoice: false,
      showMobileFilter: false,
      invoiceTrips: [],
      totalTripAmount: 0,
      invoices: [],
      expandedInvoices: {},
      selectedFromDate: dayjs().startOf("week").add(1, "day"),
      selectedToDate: dayjs().endOf("day"),
      selectedStatus: "",
      showRemarkModal: false,
      filterApplyLoading: false,
      selectedInvoiceComment: "",
      resubmitLoading: {},
      showEditInvoiceModal: false,
      showManageModal: false,
      selectedInvoice: null,
      activeTab: "grouped",
      groupedTrips: [],
      availableTrips: [],
      updateTripsLoading: false,
      actionMessage: "",
      showTripsModal: false,
      selectedTripsData: [],
      selectedInvoiceForTrips: null,
      showPdfModal: false,
      pdfData: null,
      pdfFileName: null,
      downloadLoading: {},
      selectedInvoiceForDownload: null,
      isDownloadingPdf: false,
      locallyModifiedTrips: {},
    };
  }

  async componentDidMount() {
    try {
      const stateObj = { loading: false };
      const invoices = await this.fetchInvoice();
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      this.decodedToken = decodedToken;
      const userMobileNo = decodedToken.mobileNo;
      await this.fetchProfileDetails(userMobileNo);
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      stateObj.invoices = invoices;

      const expandedInvoices = {};
      if (invoices && invoices.length > 0) {
        invoices.forEach((invoice, index) => {
          expandedInvoices[invoice._id] = true;
        });
      }
      stateObj.expandedInvoices = expandedInvoices;

      this.setState(stateObj);
    } catch (err) {
      console.error(err);
    }
  }

  fetchProfileDetails = async (userMobileNo) => {
    try {
      const url = `/cabOperator/details?mobileNo=${userMobileNo}`;
      const options = {
        method: "get",
      };

      const response = await Fetch(url, options);
      if (response) {
        const userDetails = response[0];
        const isRcm = userDetails.isRcm;

        this.setState({
          isRcm: isRcm === true,
        });
      } else {
        console.warn(`No data found for mobile number: ${userMobileNo}`);
      }
    } catch (error) {
      console.error("Error fetching profile details:", error);
    }
  };

  fetchInvoice = async (fromDate = null, toDate = null, status = null) => {
    let url = `/cabOperator/submittedInvoiceTrips`;

    let fromDateMillis = this.state.selectedFromDate.valueOf();
    let toDateMillis = this.state.selectedToDate.valueOf();

    if (fromDate && toDate) {
      fromDateMillis = moment(fromDate).valueOf();
      toDateMillis = moment(toDate).valueOf();
    }
    url += `?fromDate=${fromDateMillis}&toDate=${toDateMillis}`;

    if (status) {
      url +=
        fromDate && toDate
          ? `&status=${this.state.selectedStatus}`
          : `?status=${this.state.selectedStatus}`;
    }

    const options = {
      method: "get",
    };

    try {
      const response = await Fetch(url, options);

      if (Array.isArray(response) && response.length > 0) {
        return response;
      } else {
        return [];
      }
    } catch (error) {
      message.error("Failed to fetch invoice data");
      return [];
    }
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  fetchAvailableTrips = async () => {
    try {
      const fromDate = new Date();
      const toDate = new Date();

      const currentDay = fromDate.getDay();
      const distanceToMonday = currentDay === 0 ? -6 : 1 - currentDay;

      fromDate.setDate(fromDate.getDate() + distanceToMonday);
      fromDate.setHours(0, 0, 0, 0);

      toDate.setDate(fromDate.getDate() + 6);
      toDate.setHours(23, 59, 59, 999);

      const fromDateMs = fromDate.getTime();
      const toDateMs = toDate.getTime();

      const path = `/cabOperator/tripsForInvoice?fromDate=${fromDateMs}&toDate=${toDateMs}`;
      const options = {
        method: "get",
      };

      const response = await Fetch(path, options);

      if (
        response &&
        response.statusCode === "ok" &&
        Array.isArray(response.data)
      ) {
        return response.data;
      } else if (Array.isArray(response)) {
        return response;
      } else {
        console.warn("No trips found or invalid response format");
        return [];
      }
    } catch (error) {
      console.error("Error fetching available trips:", error);
      return [];
    }
  };

  formatAvailableTripsData = (tripsData) => {
    return tripsData.map((trip) => ({
      id: trip.id || trip._id,
      route: `${trip.from || trip.fromCity?.name || "N/A"} - ${trip.to || trip.toCity?.name || "N/A"}`,
      startTime: trip.startTime || null,
      startTimeFormatted: trip.startTime
        ? new Date(trip.startTime).toLocaleString()
        : "N/A",
      tripId: trip.groupCode || "N/A",
      assetType: trip.seater || trip.assetType || "N/A",
      amount: trip.supplyCost || 0,
      fromCity: trip.fromCity || { name: trip.from || "N/A" },
      toCity: trip.toCity || { name: trip.to || "N/A" },
      groupCode: trip.groupCode || "N/A",
      supplyCost: trip.supplyCost || 0,
      isIntraCity: trip.isIntraCity || false,
      lastModifiedOn: trip.lastModifiedOn || null,
    }));
  };

  onRangeChange = async (dates, dateStrings) => {
    if (dates) {
      const fromDate = moment(dateStrings[0], "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      const toDate = moment(dateStrings[1], "DD/MM/YYYY").format("YYYY-MM-DD");

      this.setState({
        selectedFromDate: fromDate,
        selectedToDate: toDate,
        currentDateRange: { dates, dateStrings },
      });
    } else {
      this.setState({
        selectedFromDate: null,
        selectedToDate: null,
        currentDateRange: {
          dates: [
            dayjs().startOf("week").add(1, "day"),
            dayjs().endOf("week").add(1, "day"),
          ],
        },
      });
    }
  };

  applyDateFilter = async () => {
    const { selectedFromDate, selectedToDate, selectedStatus } = this.state;
    const isDateFilteredApplied = selectedFromDate && selectedToDate;
    const isStatusFilteredApplied = selectedStatus;
    this.setState({ filterApplyLoading: true });

    try {
      let invoices;
      if (isDateFilteredApplied) {
        invoices = await this.fetchInvoice(
          selectedFromDate,
          selectedToDate,
          selectedStatus
        );
      } else if (isStatusFilteredApplied) {
        invoices = await this.fetchInvoice(null, null, selectedStatus);
      } else {
        invoices = await this.fetchInvoice();
      }

      const expandedInvoices = {};
      if (invoices && invoices.length > 0) {
        invoices.forEach((invoice, index) => {
          expandedInvoices[invoice._id] = true;
        });
      }

      this.setState({
        invoices,
        expandedInvoices,
        filterApplyLoading: false,
        showMobileFilter: false,
        isDateFilteredApplied,
        isStatusFilteredApplied,
      });
    } catch (error) {
      console.error("Error fetching invoices:", error);
      this.setState({ filterApplyLoading: false });
    }
  };

  toggleInvoiceExpansion = (invoiceId) => {
    const { expandedInvoices } = this.state;
    this.setState({
      expandedInvoices: {
        ...expandedInvoices,
        [invoiceId]: !expandedInvoices[invoiceId],
      },
    });
  };

  handleRemarkClick = (invoice) => {
    this.setState({
      showRemarkModal: true,
      selectedInvoiceComment: invoice.comment || "No comment available",
    });
  };

  closeRemarkModal = () => {
    this.setState({
      showRemarkModal: false,
      selectedInvoiceComment: "",
    });
  };

  handleDownloadInvoice = async (invoice) => {
    this.setState({
      downloadLoading: {
        ...this.state.downloadLoading,
        [invoice._id]: true,
      },
    });

    try {
      const path = `/cabOperator/generateInvoice`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          invoiceId: invoice._id,
          invoiceNumber: invoice.invoiceNumber,
          isDownload: false,
        },
      };

      const pdfData = await downloadPDF(path, options, true);

      if (
        pdfData &&
        typeof pdfData === "object" &&
        pdfData.statusCode === "error"
      ) {
        message.error(pdfData.message || "Failed to generate invoice PDF");
        return;
      }

      if (pdfData) {
        try {
          const blob = new Blob([pdfData], { type: "application/pdf" });

          if (blob.size === 0) {
            throw new Error("Empty PDF blob generated");
          }

          const pdfUrl = window.URL.createObjectURL(blob);
          const fileName = `invoice_${invoice.invoiceNumber}_${moment().format(
            "YYYY-MM-DD"
          )}.pdf`;

          this.pdfBlob = blob;

          this.setState({
            showPdfModal: true,
            pdfData: pdfUrl,
            pdfFileName: fileName,
            selectedInvoiceForDownload: invoice,
          });
        } catch (blobError) {
          console.error("Blob creation error:", blobError);
          message.error("Failed to process PDF data");
        }
      } else {
        message.error("No PDF data received from server");
      }
    } catch (error) {
      message.error("Failed to generate invoice PDF");
      console.error("PDF generation error:", error);
    } finally {
      this.setState({
        downloadLoading: {
          ...this.state.downloadLoading,
          [invoice._id]: false,
        },
      });
    }
  };

  handleActualDownload = async (e) => {
    e.preventDefault();
    const { selectedInvoiceForDownload } = this.state;

    if (!selectedInvoiceForDownload) {
      message.error("Invoice information not found");
      return;
    }

    this.setState({ isDownloadingPdf: true });

    try {
      const path = `/cabOperator/generateInvoice`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          invoiceId: selectedInvoiceForDownload._id,
          invoiceNumber: selectedInvoiceForDownload.invoiceNumber,
          isDownload: true,
        },
      };

      const pdfData = await downloadPDF(path, options, true);

      if (
        pdfData &&
        typeof pdfData === "object" &&
        pdfData.statusCode === "error"
      ) {
        message.error(pdfData.message || "Failed to download invoice PDF");
        this.setState({ isDownloadingPdf: false });
        return;
      }

      if (pdfData) {
        try {
          const blob = new Blob([pdfData], { type: "application/pdf" });

          if (blob.size === 0) {
            throw new Error("Empty PDF blob generated");
          }

          const fileName = `invoice_${selectedInvoiceForDownload.invoiceNumber
            }_${moment().format("YYYY-MM-DD")}.pdf`;

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        } catch (blobError) {
          console.error("Blob creation error:", blobError);
          message.error("Failed to process PDF data");
        }
      } else {
        message.error("No PDF data received from server");
      }
    } catch (error) {
      message.error("Failed to download invoice PDF");
      console.error("PDF download error:", error);
    } finally {
      this.setState({ isDownloadingPdf: false });
    }
  };

  closePdfModal = () => {
    if (this.state.pdfData) {
      URL.revokeObjectURL(this.state.pdfData);
    }
    this.pdfBlob = null;
    this.setState({
      showPdfModal: false,
      pdfData: null,
      pdfFileName: null,
      selectedInvoiceForDownload: null,
      isDownloadingPdf: false,
    });
  };

  handleShowTripsClick = (invoice) => {
    const displayTrips = this.getDisplayTripsForInvoice(invoice);

    const tripsData = displayTrips.map((trip) => ({
      id: trip._id || trip.id,
      route: `${trip.fromCity?.name || "N/A"} - ${trip.toCity?.name || "N/A"
        }`,
      startTime: trip.startTime
        ? moment(trip.startTime).format("h:mm A")
        : "N/A",
      startDate: trip.startTime
        ? moment(trip.startTime).format("MMM D, YYYY")
        : "N/A",
      tripId: trip.groupCode || trip.tripId || "N/A",
      assetType: trip.assetType || "N/A",
      amount: trip.supplyCost || trip.amount || 0,
      passengers: trip.totalPassengers || 0,
      isIntraCity: trip.isIntraCity,
      lastModifiedOn: trip.lastModifiedOn,
      fromCity: trip.fromCity,
      toCity: trip.toCity,
    }));

    this.setState({
      showTripsModal: true,
      selectedTripsData: tripsData,
      selectedInvoiceForTrips: invoice,
    });
  };

  closeTripsModal = () => {
    this.setState({
      showTripsModal: false,
      selectedTripsData: [],
      selectedInvoiceForTrips: null,
    });
  };

  handleManageClick = async (invoice) => {
    const { locallyModifiedTrips } = this.state;

    let groupedTrips;
    if (locallyModifiedTrips[invoice._id]) {
      groupedTrips = locallyModifiedTrips[invoice._id].trips;
    } else {
      groupedTrips = invoice.cabBookingGroups
        ? invoice.cabBookingGroups.map((trip) => ({
          id: trip._id,
          route: `${trip.fromCity?.name || "N/A"} - ${trip.toCity?.name || "N/A"
            }`,
          startTime: trip.startTime || null,
          startTimeFormatted: trip.startTime
            ? new Date(trip.startTime).toLocaleString()
            : "N/A",
          tripId: trip.groupCode || "N/A",
          assetType: trip.assetType || "N/A",
          amount: trip.supplyCost || 0,
          fromCity: trip.fromCity,
          toCity: trip.toCity,
          groupCode: trip.groupCode || "N/A",
          supplyCost: trip.supplyCost || 0,
          isIntraCity: trip.isIntraCity || false,
          lastModifiedOn: trip.lastModifiedOn || null,
        }))
        : [];
    }

    const tripsData = await this.fetchAvailableTrips();
    const allAvailableTrips = this.formatAvailableTripsData(tripsData);

    const originalTrips = invoice.cabBookingGroups || [];
    const currentGroupedIds = groupedTrips.map((trip) => trip.id);

    const removedTrips = originalTrips
      .filter((trip) => !currentGroupedIds.includes(trip._id))
      .map((trip) => ({
        id: trip._id,
        route: `${trip.fromCity?.name || "N/A"} - ${trip.toCity?.name || "N/A"
          }`,
        startTime: trip.startTime || null,
        startTimeFormatted: trip.startTime
          ? new Date(trip.startTime).toLocaleString()
          : "N/A",
        tripId: trip.groupCode || "N/A",
        assetType: trip.assetType || "N/A",
        amount: trip.supplyCost || 0,
        fromCity: trip.fromCity,
        toCity: trip.toCity,
        groupCode: trip.groupCode || "N/A",
        supplyCost: trip.supplyCost || 0,
        isIntraCity: trip.isIntraCity || false,
        lastModifiedOn: trip.lastModifiedOn || null,
      }));

    const combinedAvailableTrips = [...allAvailableTrips, ...removedTrips];
    const availableTrips = combinedAvailableTrips.filter(
      (trip) => !currentGroupedIds.includes(trip.id)
    );

    this.setState({
      showManageModal: true,
      selectedInvoice: invoice,
      activeTab: "grouped",
      groupedTrips,
      availableTrips,
      initialGroupedTripsIds: groupedTrips.map((trip) => trip.id),
      actionMessage: "",
    });
  };

  closeManageModal = () => {
    this.setState({
      showManageModal: false,
      selectedInvoice: null,
      activeTab: "grouped",
      groupedTrips: [],
      availableTrips: [],
      updateTripsLoading: false,
      actionMessage: "",
      initialGroupedTripsIds: [],
    });
  };

  switchTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  removeTripFromGrouped = (tripId) => {
    const { groupedTrips, availableTrips, initialGroupedTripsIds } = this.state;
    const tripToRemove = groupedTrips.find((trip) => trip.id === tripId);

    if (tripToRemove) {
      const newAvailableTrips = [...availableTrips, tripToRemove];
      const newGroupedTrips = groupedTrips.filter((trip) => trip.id !== tripId);
      const currentGroupedTripIds = newGroupedTrips.map((trip) => trip.id);

      const tripsRemoved = initialGroupedTripsIds.filter(
        (id) => !currentGroupedTripIds.includes(id)
      ).length;
      const tripsAdded = currentGroupedTripIds.filter(
        (id) => !initialGroupedTripsIds.includes(id)
      ).length;

      let message = "";
      if (tripsRemoved > 0 && tripsAdded > 0) {
        message = `${tripsRemoved} ${tripsRemoved === 1 ? "trip" : "trips"
          } removed, ${tripsAdded} ${tripsAdded === 1 ? "trip" : "trips"} added`;
      } else if (tripsRemoved > 0) {
        message = `${tripsRemoved} ${tripsRemoved === 1 ? "trip" : "trips"
          } removed`;
      } else if (tripsAdded > 0) {
        message = `${tripsAdded} ${tripsAdded === 1 ? "trip" : "trips"} added`;
      }

      this.setState({
        groupedTrips: newGroupedTrips,
        availableTrips: newAvailableTrips,
        actionMessage: message,
      });
    }
  };

  addTripToGrouped = (tripId) => {
    const { groupedTrips, availableTrips, initialGroupedTripsIds } = this.state;
    const tripToAdd = availableTrips.find((trip) => trip.id === tripId);

    if (tripToAdd) {
      const newGroupedTrips = [...groupedTrips, tripToAdd];
      const newAvailableTrips = availableTrips.filter(
        (trip) => trip.id !== tripId
      );
      const currentGroupedTripIds = newGroupedTrips.map((trip) => trip.id);

      const tripsRemoved = initialGroupedTripsIds.filter(
        (id) => !currentGroupedTripIds.includes(id)
      ).length;
      const tripsAdded = currentGroupedTripIds.filter(
        (id) => !initialGroupedTripsIds.includes(id)
      ).length;

      let message = "";
      if (tripsRemoved > 0 && tripsAdded > 0) {
        message = `${tripsRemoved} ${tripsRemoved === 1 ? "trip" : "trips"
          } removed, ${tripsAdded} ${tripsAdded === 1 ? "trip" : "trips"} added`;
      } else if (tripsRemoved > 0) {
        message = `${tripsRemoved} ${tripsRemoved === 1 ? "trip" : "trips"
          } removed`;
      } else if (tripsAdded > 0) {
        message = `${tripsAdded} ${tripsAdded === 1 ? "trip" : "trips"} added`;
      }

      this.setState({
        groupedTrips: newGroupedTrips,
        availableTrips: newAvailableTrips,
        actionMessage: message,
      });
    }
  };

  updateTripsCommon = async (
    invoice,
    cabBookingGroupIds,
    operationType = "update"
  ) => {
    try {
      if (operationType === "resubmit") {
        this.setState({
          resubmitLoading: {
            ...this.state.resubmitLoading,
            [invoice._id]: true,
          },
        });
      }

      if (!invoice._id) {
        message.error("Invoice ID is missing");
        return false;
      }

      if (!cabBookingGroupIds || cabBookingGroupIds.length === 0) {
        message.error("No booking group IDs provided");
        return false;
      }

      const currentTime = moment().format("DD-MM-YYYY HH:mm");
      const shouldMarkPending =
        operationType === "resubmit" || operationType === "manage";
      const managerName =
        this.decodedToken?.name || this.decodedToken?.mgName;
      const previousStatus = invoice.status;
      const previousStage = invoice.stage;
      const newStatus = shouldMarkPending ? "PENDING" : invoice.status;
      const newStage = shouldMarkPending
        ? "PENDING_BY_RM"
        : invoice.stage || "PENDING_BY_RM";

      const requestBody = {
        _id: invoice._id,
        invoiceNumber: invoice.invoiceNumber,
        status: newStatus,
        stage: newStage,
        remark:
          operationType === "resubmit"
            ? invoice.remark
              ? `${invoice.remark} || status moved from ${previousStatus} to ${newStatus} by ${managerName} at ${currentTime} || stage moved from ${previousStage} to ${newStage} by ${managerName} at ${currentTime}`
              : `status moved from ${previousStatus} to ${newStatus} by ${managerName} at ${currentTime} || stage moved from ${previousStage} to ${newStage} by ${managerName} at ${currentTime}`
            : invoice.remark,
        cabBookingGroupIds: cabBookingGroupIds,
      };

      const url = `/cabOperator/updateTrips`;
      const options = {
        method: "post",
        data: requestBody,
      };

      const response = await Fetch(url, options);

      if (
        response &&
        (response.statusCode === "ok" || Array.isArray(response))
      ) {
        const successMessage =
          operationType === "resubmit"
            ? "Invoice resubmitted successfully!"
            : "Invoice trips updated successfully!";
        message.success(successMessage);

        const invoices = await this.fetchInvoice();
        const expandedInvoices = {};
        if (invoices && invoices.length > 0) {
          invoices.forEach((invoice, index) => {
            expandedInvoices[invoice._id] = true;
          });
        }

        if (operationType === "resubmit") {
          this.setState({
            invoices,
            expandedInvoices,
            resubmitLoading: {
              ...this.state.resubmitLoading,
              [invoice._id]: false,
            },
          });
        } else {
          this.setState({ invoices, expandedInvoices });
        }
        return true;
      } else {
        const errorMessage =
          operationType === "resubmit"
            ? "Failed to resubmit invoice. Please try again."
            : "Failed to update invoice trips. Please try again.";
        message.error(errorMessage);
        return false;
      }
    } catch (error) {
      const errorMessage =
        operationType === "resubmit"
          ? "Failed to resubmit invoice. Please check your connection and try again."
          : "Failed to update invoice trips. Please check your connection and try again.";
      message.error(errorMessage);

      if (operationType === "resubmit") {
        this.setState({
          resubmitLoading: {
            ...this.state.resubmitLoading,
            [invoice._id]: false,
          },
        });
      }
      return false;
    }
  };

  handleResubmitClick = async (invoice) => {
    const { locallyModifiedTrips } = this.state;
    const cabBookingGroupIds = locallyModifiedTrips[invoice._id]
      ? locallyModifiedTrips[invoice._id].ids
      : invoice.cabBookingGroupIds || [];

    if (this.state.isRcm) {
      await this.updateTripsCommon(invoice, cabBookingGroupIds, "resubmit");

      if (locallyModifiedTrips[invoice._id]) {
        const updatedLocalTrips = { ...locallyModifiedTrips };
        delete updatedLocalTrips[invoice._id];
        this.setState({ locallyModifiedTrips: updatedLocalTrips });
      }
    } else {
      this.setState({ showEditInvoiceModal: true, resubmitInvoice: invoice });
    }
  };

  handleEditInvoice = async () => {
    const { resubmitInvoice, locallyModifiedTrips } = this.state;
    const invoice = resubmitInvoice;

    const cabBookingGroupIds = locallyModifiedTrips[invoice._id]
      ? locallyModifiedTrips[invoice._id].ids
      : invoice.cabBookingGroupIds || [];

    this.setState({ showEditInvoiceModal: false, resubmitInvoice: null });
    await this.updateTripsCommon(invoice, cabBookingGroupIds, "resubmit");

    if (locallyModifiedTrips[invoice._id]) {
      const updatedLocalTrips = { ...locallyModifiedTrips };
      delete updatedLocalTrips[invoice._id];
      this.setState({ locallyModifiedTrips: updatedLocalTrips });
    }
  };

  handleUpdateTripsFromManage = async () => {
    const { selectedInvoice, groupedTrips, locallyModifiedTrips } = this.state;

    if (!selectedInvoice) {
      message.error("No invoice selected");
      return;
    }

    if (groupedTrips.length === 0) {
      message.error("At least one trip must be grouped");
      return;
    }

    const cabBookingGroupIds = groupedTrips.map((trip) => trip.id);

    this.setState({
      locallyModifiedTrips: {
        ...locallyModifiedTrips,
        [selectedInvoice._id]: {
          ids: cabBookingGroupIds,
          trips: groupedTrips,
        },
      },
    });

    message.success(
      "Changes saved locally. Click Resubmit to confirm resubmission."
    );
    this.closeManageModal();
  };

  formatData = (response) => {
    const data = response.map((data) => {
      return {
        rc: data.rc,
        status: data.status,
        type: data.busType?.name || "N/A",
      };
    });
    return data;
  };

  directSearh = async (value) => {
    const { allData } = this.state;
    let filterData = allData.filter((data) => data.rc == value);
    this.setState({ invoiceTableData: filterData });
  };

  showMore = (key, trips) => {
    const { selectedKey } = this.state;
    if (selectedKey == key)
      this.setState({
        selectedKey: null,
        invoiceTrips: [],
        totalTripAmount: 0,
      });
    else {
      const invoiceTrips = trips.map((trip, index) => ({
        key: index,
        route: trip.Route,
        date: trip["Start Time & Date"],
        tripId: trip["Trip ID"],
        assetType: trip["Asset Type"],
        amount: trip.Amount,
      }));
      const totalTripAmount = invoiceTrips.reduce(
        (total, trip) => total + trip.amount,
        0
      );
      this.setState({ selectedKey: key, invoiceTrips, totalTripAmount });
    }
  };

  manageInvoice = (invoiceNumber, trips) => {
    this.setState({
      selectedKey: invoiceNumber,
      invoiceTrips: trips,
      showManageInvoice: true,
    });
  };

  toggleMobileFilter = () => {
    this.setState({ showMobileFilter: !this.state.showMobileFilter });
  };

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  hasTripsChanged = () => {
    const { groupedTrips, initialGroupedTripsIds } = this.state;
    if (!groupedTrips || !initialGroupedTripsIds) {
      return false;
    }
    const currentTripIds = groupedTrips.map((trip) => trip.id).sort();
    const initialTripIds = [...initialGroupedTripsIds].sort();

    if (currentTripIds.length !== initialTripIds.length) {
      return true;
    }

    return !currentTripIds.every((id, index) => id === initialTripIds[index]);
  };

  // Get display trips for an invoice (locally modified or original)
  getDisplayTripsForInvoice = (invoice) => {
    const { locallyModifiedTrips } = this.state;

    if (!invoice.cabBookingGroups) {
      return [];
    }

    if (locallyModifiedTrips[invoice._id]) {
      return locallyModifiedTrips[invoice._id].trips;
    }

    return invoice.cabBookingGroups;
  };

  render() {
    const {
      loading,
      invoices,
      isMobile,
      expandedInvoices,
      showSideMenu,
      showManageInvoice,
      selectedKey,
      showMobileFilter,
      showRemarkModal,
      selectedInvoiceComment,
      selectedFromDate,
      selectedToDate,
      selectedStatus,
      filterApplyLoading,
      resubmitLoading,
      showManageModal,
      selectedInvoice,
      activeTab,
      groupedTrips,
      availableTrips,
      updateTripsLoading,
      actionMessage,
      showTripsModal,
      selectedTripsData,
      selectedInvoiceForTrips,
      showPdfModal,
      pdfData,
      downloadLoading,
      showEditInvoiceModal,
      resubmitInvoice,
      isDateFilteredApplied = false,
      isStatusFilteredApplied = false,
      isDownloadingPdf,
      locallyModifiedTrips,
    } = this.state;

    const hasChanges = showManageModal ? this.hasTripsChanged() : false;

    let active = 10;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    }
    if (isMobile) {
      return (
        <>
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={active}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          {showManageInvoice ? (
            <div className={less.manageInvoice}>
              <div className={less.header}>
                <img
                  onClick={() => this.setState({ showManageInvoice: false })}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operator/backarrow.svg"
                  alt="back arrow"
                />
                <div>
                  <span>Manage Invoices</span>
                  <span>Invoice Number: {selectedKey}</span>
                </div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operator/backarrow.svg"
                  alt="back arrow"
                  className={less.backImg}
                />
              </div>
              <div className={less.footer}>
                <div>
                  <img src="" alt="" />
                  <span>1 trips removed</span>
                </div>
                <button
                  onClick={() => this.setState({ createInvoiceModal: true })}
                >
                  Update
                </button>
              </div>
            </div>
          ) : (
            <>
              {" "}
              <div class="container">
                <div className={less.header}>
                  <div>
                    <span>Submitted Invoices</span>
                    <span>
                      View complete details of your submitted invoices
                    </span>
                  </div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/operatorWallet/filter.svg"
                    alt="filter"
                    onClick={this.toggleMobileFilter}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                {isDateFilteredApplied || isStatusFilteredApplied ? (
                  <div className={less.filterBar}>
                    {isDateFilteredApplied ? (
                      <div
                        className={less.filterBar}
                        onClick={this.toggleMobileFilter}
                      >
                        <span>
                          {moment(new Date(selectedFromDate).getTime()).format(
                            "DD MMM YYYY"
                          )}{" "}
                          -{" "}
                          {moment(new Date(selectedToDate).getTime()).format(
                            "DD MMM YYYY"
                          )}
                        </span>
                        <span>×</span>
                      </div>
                    ) : null}
                    {isStatusFilteredApplied ? (
                      <div
                        className={less.filterItem}
                        onClick={this.toggleMobileFilter}
                      >
                        <span>{selectedStatus}</span>
                        <span>×</span>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <div className={less.body}>
                  {invoices.length > 0 ? (
                    invoices.map((invoice, index) => {
                      const displayTrips =
                        this.getDisplayTripsForInvoice(invoice);
                      return (
                        <div key={invoice._id} className={less.tableWrapper}>
                          <div className={less.invoiceHeader}>
                            <div>
                              <span>#{invoice.invoiceNumber}</span>
                              <div
                                className={
                                  invoice.status === "REJECTED"
                                    ? less.rejected
                                    : invoice.status === "APPROVED"
                                      ? less.confirmed
                                      : less.pending
                                }
                              >
                                <div></div>
                                <span>{invoice.status}</span>
                              </div>
                            </div>
                            <div>
                              <span>
                                ₹
                                {displayTrips.reduce(
                                  (total, group) =>
                                    total + (group.supplyCost || 0),
                                  0
                                )}
                              </span>
                              <span>
                                Trips: <b>{displayTrips.length}</b>
                              </span>
                            </div>
                          </div>
                          <div className={less.invoice}>
                            {displayTrips.length > 0 && (
                              <>
                                <div className={less.tripHeader}>
                                  <span>
                                    {displayTrips[0]?.fromCity?.name || "N/A"} -{" "}
                                    {displayTrips[0]?.toCity?.name || "N/A"}
                                  </span>
                                  <span>
                                    {displayTrips[0]?.assetType || "N/A"}
                                  </span>
                                </div>
                                <div className={less.tripDetails}>
                                  <span>
                                    {displayTrips[0]?.startTime
                                      ? new Date(
                                        displayTrips[0].startTime
                                      ).toLocaleTimeString("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      : "N/A"}
                                  </span>
                                  <div className={less.divider}></div>
                                  <span>
                                    {displayTrips[0]?.startTime
                                      ? new Date(
                                        displayTrips[0].startTime
                                      ).toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric",
                                      })
                                      : "N/A"}
                                  </span>
                                </div>
                                <span>
                                  Trip ID: {displayTrips[0]?.groupCode || "N/A"}
                                </span>
                                <div className={less.amountWithTags}>
                                  <span>
                                    Amount: ₹{displayTrips[0]?.supplyCost || 0}
                                  </span>
                                  {(displayTrips[0]?.isIntraCity ||
                                    (displayTrips[0]?.lastModifiedOn &&
                                      invoice.lastRejectedOn &&
                                      displayTrips[0]?.lastModifiedOn >
                                      invoice.lastRejectedOn)) && (
                                      <span className={less.tripTags}>
                                        {displayTrips[0]?.isIntraCity && (
                                          <span
                                            className={less.intraTag}
                                            title={`${displayTrips[0]?.fromCity?.name ||
                                              "N/A"
                                              } - ${displayTrips[0]?.toCity?.name ||
                                              "N/A"
                                              }`}
                                          >
                                            <img
                                              src={intraIcon}
                                              alt="Intra"
                                              className={less.tagIcon}
                                            />
                                            Intra
                                          </span>
                                        )}
                                        {displayTrips[0]?.lastModifiedOn &&
                                          invoice.lastRejectedOn &&
                                          displayTrips[0]?.lastModifiedOn >
                                          invoice.lastRejectedOn && (
                                            <span
                                              className={less.editedTag}
                                              title="This trip has been edited"
                                            >
                                              <img
                                                src={editedIcon}
                                                alt="Edited"
                                                className={less.tagIcon}
                                              />
                                              Edited
                                            </span>
                                          )}
                                      </span>
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                          {displayTrips.length > 1 && (
                            <div
                              className={less.invoiceTrips}
                              onClick={() => this.handleShowTripsClick(invoice)}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div style={{ width: "30%" }}></div>
                              <span style={{ width: "80px" }}>
                                +{displayTrips.length - 1} more trips{" "}
                                <span
                                  style={{ width: "20px" }}
                                  className={less.arrowIcon}
                                >
                                  {">"}
                                </span>
                              </span>
                              <div style={{ width: "30%" }}></div>
                            </div>
                          )}
                          <div className={less.invoiceActions}>
                            {invoice.status === "APPROVED" ||
                              invoice.status === "PENDING" ? (
                              <button
                                onClick={() =>
                                  this.handleDownloadInvoice(invoice)
                                }
                                disabled={downloadLoading[invoice._id]}
                                style={{
                                  cursor: downloadLoading[invoice._id]
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: downloadLoading[invoice._id]
                                    ? 0.6
                                    : 1,
                                }}
                              >
                                <img src={downloadIcon} alt="download" />
                                {downloadLoading[invoice._id]
                                  ? "Generating..."
                                  : "Download"}
                              </button>
                            ) : (
                              <>
                                {invoice.status === "REJECTED" && (
                                  <button
                                    onClick={() =>
                                      this.handleResubmitClick(invoice)
                                    }
                                    disabled={resubmitLoading[invoice._id]}
                                    style={{
                                      opacity: resubmitLoading[invoice._id]
                                        ? 0.6
                                        : 1,
                                      cursor: resubmitLoading[invoice._id]
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    <img
                                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/circular-arrow.svg"
                                      alt="Resubmit"
                                    />
                                    {resubmitLoading[invoice._id]
                                      ? "Resubmitting..."
                                      : "Resubmit"}
                                  </button>
                                )}

                                <button
                                  onClick={() =>
                                    this.handleRemarkClick(invoice)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <img src={remarkMobileIcon} alt="remark" />
                                  Remark{" "}
                                </button>
                                <button
                                  onClick={() =>
                                    this.handleManageClick(invoice)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/Manage.svg"
                                    alt="manage"
                                  />
                                  Manage{" "}
                                </button>
                              </>
                            )}
                          </div>

                          {locallyModifiedTrips[invoice._id] && (
                            <div
                              className={`${less.localChangesBanner} ${less.localChangesBannerCardMobile}`}
                            >
                              <span
                                className={less.localChangesBannerTextSmall}
                              >
                                This invoice group has unsaved changes. Click
                                Resubmit to submit the invoice.
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className={less.noData}>No Invoices Found</div>
                  )}
                </div>
              </div>
            </>
          )}

          {showMobileFilter && (
            <>
              <div
                className={less.mobileFilterOverlay}
                onClick={this.toggleMobileFilter}
              ></div>

              <div className={less.mobileFilterPopup}>
                <div
                  className={less.mobileFilterHandle}
                  onClick={this.toggleMobileFilter}
                ></div>

                <div className={less.mobileFilterHeader}>
                  <div className={less.mobileFilterTitle}>Filter Options</div>
                  <div
                    className={less.mobileFilterClose}
                    onClick={this.toggleMobileFilter}
                  >
                    ×
                  </div>
                </div>

                <div className={less.mobileFilterContent}>
                  <div className={less.mobileFilterField}>
                    <label className={less.mobileFilterLabel}>From Date</label>
                    <DatePicker
                      className={less.mobileFilterInput}
                      value={
                        !selectedFromDate
                          ? null
                          : typeof selectedFromDate === "string"
                            ? dayjs(selectedFromDate)
                            : selectedFromDate
                      }
                      onChange={(date) =>
                        this.setState({ selectedFromDate: date })
                      }
                      placeholder="Select from date"
                      format="DD/MM/YYYY"
                      disabledDate={(current) =>
                        current && current.isAfter(dayjs(), "day")
                      }
                    />
                  </div>

                  <div className={less.mobileFilterField}>
                    <label className={less.mobileFilterLabel}>To Date</label>
                    <DatePicker
                      className={less.mobileFilterInput}
                      value={
                        !selectedToDate
                          ? null
                          : typeof selectedToDate === "string"
                            ? dayjs(selectedToDate)
                            : selectedToDate
                      }
                      onChange={(date) =>
                        this.setState({ selectedToDate: date })
                      }
                      placeholder="Select to date"
                      format="DD/MM/YYYY"
                      disabledDate={(current) =>
                        current && current.isAfter(dayjs(), "day")
                      }
                    />
                  </div>

                  <div className={less.mobileFilterField}>
                    <label className={less.mobileFilterLabel}>Status</label>
                    <Select
                      className={less.mobileFilterInput}
                      value={selectedStatus}
                      onChange={(value) =>
                        this.setState({ selectedStatus: value })
                      }
                      placeholder="Select status"
                    >
                      <Option value="">All Status</Option>
                      <Option value="PENDING">Pending</Option>
                      <Option value="APPROVED">Approved</Option>
                      <Option value="REJECTED">Rejected</Option>
                    </Select>
                  </div>

                  <div className={less.mobileFilterButtonContainer}>
                    <button
                      className={less.mobileFilterButton}
                      onClick={() => {
                        this.toggleMobileFilter();
                        this.applyDateFilter();
                      }}
                      disabled={filterApplyLoading}
                    >
                      {filterApplyLoading ? "Searching..." : "Search"}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {showRemarkModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "340px",
                  maxHeight: "80vh",
                  overflow: "auto",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div
                  style={{
                    padding: "24px 24px 0 24px",
                    textAlign: "center",
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Remark
                </div>

                <div
                  style={{
                    padding: "24px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "20px",
                      lineHeight: "1.5",
                      margin: 0,
                      marginBottom: "24px",
                      color: "#333",
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {selectedInvoiceComment}
                  </div>

                  <button
                    onClick={this.closeRemarkModal}
                    style={{
                      width: "100%",
                      height: "48px",
                      backgroundColor: "#F1E9FF",
                      color: "#7B2AFF",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "16px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#E6D9FF")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#F1E9FF")
                    }
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {showManageModal &&
            selectedInvoice &&
            (isMobile ? (
              <div
                style={{
                  position: "fixed",
                  top: "56px",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "white",
                  zIndex: 10,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    padding: "16px",
                    borderBottom: "1px solid #eee",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <button
                    onClick={this.closeManageModal}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#666",
                      padding: "4px",
                      borderRadius: "4px",
                    }}
                  >
                    ←
                  </button>
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#333",
                      textAlign: "center",
                      flex: 1,
                    }}
                  >
                    Manage Trips
                  </div>
                  <div style={{ width: "28px" }}></div>
                </div>

                <div
                  style={{
                    flex: 1,
                    overflow: "auto",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      textAlign: "center",
                    }}
                  >
                    <div>Invoice Number: {selectedInvoice.invoiceNumber}</div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      borderBottom: "1px solid #eee",
                      marginBottom: "16px",
                    }}
                  >
                    <button
                      onClick={() => this.switchTab("grouped")}
                      style={{
                        padding: "8px 16px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#666",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                        width: "50%",
                        borderBottom:
                          activeTab === "grouped"
                            ? "3px solid #7B2AFF"
                            : "3px solid transparent",
                      }}
                    >
                      Grouped Trips ({groupedTrips.length})
                    </button>
                    <button
                      onClick={() => this.switchTab("available")}
                      style={{
                        padding: "8px 16px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#666",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                        width: "50%",
                        borderBottom:
                          activeTab === "available"
                            ? "3px solid #7B2AFF"
                            : "3px solid transparent",
                      }}
                    >
                      Available Trips ({availableTrips.length})
                    </button>
                  </div>

                  {activeTab === "grouped" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      {groupedTrips.map((trip) => {
                        return (
                          <div
                            key={trip.id}
                            style={{
                              border: "1px solid #f1f1f1",
                              borderRadius: "12px",
                              padding: "16px",
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#292929",
                                marginBottom: "8px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span>{trip.route}</span>
                              <span
                                style={{ fontWeight: "600", color: "#292929" }}
                              >
                                ₹{trip.amount || 0}
                              </span>
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "#666",
                                marginBottom: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {trip.startTime ? (
                                <span>
                                  {moment(trip.startTime).format("hh:mm A")}
                                </span>
                              ) : (
                                <span>Unknown</span>
                              )}
                              <span style={{ color: "#999" }}>•</span>
                              {trip.startTime ? (
                                <span>
                                  {moment(trip.startTime).format("MMM D, YYYY")}
                                </span>
                              ) : (
                                <span>Unknown</span>
                              )}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                color: "#999",
                                marginBottom: "8px",
                              }}
                            >
                              {trip.assetType}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                color: "#999",
                                marginBottom: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <span
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontSize: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                Trip ID
                              </span>
                              <span>{trip.tripId}</span>
                            </div>

                            <button
                              onClick={() =>
                                this.removeTripFromGrouped(trip.id)
                              }
                              style={{
                                width: "100%",
                                padding: "12px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "transparent",
                                color: "#666",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              <span
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  border: "none",
                                  backgroundColor: "rgb(245, 152, 21)",
                                  color: "white",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "16px",
                                }}
                              >
                                −
                              </span>
                              Ungroup
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {activeTab === "available" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      {availableTrips.map((trip) => {
                        return (
                          <div
                            key={trip.id}
                            style={{
                              border: "1px solid #f1f1f1",
                              borderRadius: "12px",
                              padding: "16px",
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#292929",
                                marginBottom: "8px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span>{trip.route}</span>
                              <span
                                style={{ fontWeight: "600", color: "#292929" }}
                              >
                                ₹{trip.amount || 0}
                              </span>
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "#666",
                                marginBottom: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {trip.startTime ? (
                                <span>
                                  {moment(trip.startTime).format("hh:mm A")}
                                </span>
                              ) : (
                                <span>Unknown</span>
                              )}
                              <span style={{ color: "#999" }}>•</span>
                              {trip.startTime ? (
                                <span>
                                  {moment(trip.startTime).format("MMM D, YYYY")}
                                </span>
                              ) : (
                                <span>Unknown</span>
                              )}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                color: "#999",
                                marginBottom: "8px",
                              }}
                            >
                              {trip.assetType}
                            </div>

                            <div
                              style={{
                                fontSize: "12px",
                                color: "#999",
                                marginBottom: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <span
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontSize: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                Trip ID
                              </span>
                              <span>{trip.tripId}</span>
                            </div>

                            <button
                              onClick={() => this.addTripToGrouped(trip.id)}
                              style={{
                                width: "100%",
                                padding: "12px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "transparent",
                                color: "#666",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              <span
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  border: "none",
                                  backgroundColor: "#4BAE4F",
                                  color: "white",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "16px",
                                }}
                              >
                                +
                              </span>
                              Add
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {hasChanges && (
                  <div
                    className={`${less.localChangesBanner} ${less.localChangesBannerBorderTop}`}
                  >
                    <span className={less.localChangesBannerText}>
                      Clicking Update saves changes locally. Click Resubmit to
                      confirm submission.
                    </span>
                  </div>
                )}

                <div
                  style={{
                    padding: "16px",
                    backgroundColor: "white",
                    borderTop: "1px solid #eee",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flex: 1,
                    }}
                  >
                    {actionMessage && (
                      <>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#666"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="8" y1="6" x2="21" y2="6"></line>
                          <line x1="8" y1="12" x2="21" y2="12"></line>
                          <line x1="8" y1="18" x2="21" y2="18"></line>
                          <line x1="3" y1="6" x2="3.01" y2="6"></line>
                          <line x1="3" y1="12" x2="3.01" y2="12"></line>
                          <line x1="3" y1="18" x2="3.01" y2="18"></line>
                        </svg>
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            fontWeight: "500",
                          }}
                        >
                          {actionMessage}
                        </span>
                      </>
                    )}
                  </div>
                  <button
                    onClick={this.handleUpdateTripsFromManage}
                    disabled={!hasChanges || updateTripsLoading}
                    style={{
                      padding: "12px 24px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor:
                        !hasChanges || updateTripsLoading ? "#ccc" : "#7B2AFF",
                      color: "white",
                      cursor:
                        !hasChanges || updateTripsLoading
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "14px",
                      fontWeight: "500",
                      opacity: !hasChanges || updateTripsLoading ? 0.6 : 1,
                      flexShrink: 0,
                    }}
                  >
                    {updateTripsLoading ? "Updating..." : "Update"}
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    width: "800px",
                    maxHeight: "80vh",
                    overflow: "auto",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  }}
                >
                  <div
                    style={{
                      padding: "24px 24px 16px 24px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#333",
                      }}
                    >
                      Manage Trips in Invoice
                    </div>
                    <button
                      onClick={this.closeManageModal}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "24px",
                        cursor: "pointer",
                        color: "#666",
                        padding: "4px",
                        borderRadius: "4px",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.backgroundColor = "#f5f5f5")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                    >
                      ×
                    </button>
                  </div>

                  <div
                    style={{
                      padding: isMobile ? "12px 16px" : "16px 24px",
                      fontSize: isMobile ? "12px" : "14px",
                      color: "#666",
                    }}
                  >
                    <div>Invoice Number: {selectedInvoice.invoiceNumber}</div>
                    <div>{groupedTrips.length} trips currently grouped</div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "#eee",
                      margin: isMobile ? "0 16px" : "0 24px",
                    }}
                  ></div>

                  <div
                    style={{
                      display: "flex",
                      borderBottom: "1px solid #eee",
                      marginBottom: isMobile ? "16px" : "20px",
                      justifyContent: "flex-start",
                    }}
                  >
                    <button
                      onClick={() => this.switchTab("grouped")}
                      style={{
                        padding: isMobile ? "8px 16px" : "12px 24px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#666",
                        cursor: "pointer",
                        fontSize: isMobile ? "14px" : "16px",
                        fontWeight: "bold",
                        marginRight: "0",
                        width: isMobile ? "50%" : "auto",
                        borderBottom:
                          activeTab === "grouped"
                            ? "3px solid #7B2AFF"
                            : "3px solid transparent",
                      }}
                    >
                      Grouped Trips ({groupedTrips.length})
                    </button>
                    <button
                      onClick={() => this.switchTab("available")}
                      style={{
                        padding: isMobile ? "8px 16px" : "12px 24px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "#666",
                        cursor: "pointer",
                        fontSize: isMobile ? "14px" : "16px",
                        fontWeight: "bold",
                        width: isMobile ? "50%" : "auto",
                        borderBottom:
                          activeTab === "available"
                            ? "3px solid #7B2AFF"
                            : "3px solid transparent",
                      }}
                    >
                      Available Trips ({availableTrips.length})
                    </button>
                  </div>

                  <div
                    style={{
                      padding: isMobile
                        ? "0 16px 16px 16px"
                        : "0 24px 24px 24px",
                    }}
                  >
                    {activeTab === "grouped" && (
                      <div>
                        {isMobile ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                            }}
                          >
                            {groupedTrips.map((trip) => {
                              return (
                                <div
                                  key={trip.id}
                                  style={{
                                    border: "1px solid #f1f1f1",
                                    borderRadius: "12px",
                                    padding: "16px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      color: "#292929",
                                      marginBottom: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <span>{trip.route}</span>
                                      {trip.isIntraCity && (
                                        <span
                                          className={less.intraTag}
                                          title={`${trip.fromCity?.name || "N/A"
                                            } - ${trip.toCity?.name || "N/A"}`}
                                        >
                                          <img
                                            src={intraIcon}
                                            alt="Intra"
                                            className={less.tagIcon}
                                          />
                                          Intra
                                        </span>
                                      )}
                                      {trip.lastModifiedOn >
                                        selectedInvoice.lastRejectedOn && (
                                          <span
                                            className={less.editedTag}
                                            title="This trip has been edited"
                                          >
                                            <img
                                              src={editedIcon}
                                              alt="Edited"
                                              className={less.tagIcon}
                                            />
                                            Edited
                                          </span>
                                        )}
                                    </div>
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        color: "#292929",
                                      }}
                                    >
                                      ₹{trip.amount || 0}
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "14px",
                                      color: "#666",
                                      marginBottom: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    {trip.startTime ? (
                                      <span>
                                        {moment(trip.startTime).format(
                                          "hh:mm A"
                                        )}
                                      </span>
                                    ) : (
                                      <span>{trip.startTime}</span>
                                    )}
                                    <span style={{ color: "#999" }}>•</span>
                                    {trip.startTime ? (
                                      <span>
                                        {moment(trip.startTime).format(
                                          "MMM D, YYYY"
                                        )}
                                      </span>
                                    ) : (
                                      <span>{trip.startTime}</span>
                                    )}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {trip.assetType}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#999",
                                      marginBottom: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        padding: "2px 6px",
                                        borderRadius: "4px",
                                        fontSize: "10px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Trip ID
                                    </span>
                                    <span>{trip.tripId}</span>
                                  </div>

                                  <button
                                    onClick={() =>
                                      this.removeTripFromGrouped(trip.id)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: "12px",
                                      border: "none",
                                      borderRadius: "8px",
                                      backgroundColor: "#F59815",
                                      color: "white",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <img
                                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/ungroup.svg"
                                      alt="ungroup"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                    Ungroup
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: "14px",
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#292929" }}>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Route
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Start Time & Date
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Trip ID
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Asset Type
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Amount
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "center",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {groupedTrips.map((trip) => {
                                const isIntraCity = trip.isIntraCity;
                                const isEdited =
                                  trip.lastModifiedOn >
                                  Math.max(
                                    selectedInvoice.lastRejectedOn,
                                    trip.attachedOnInvoiceAt
                                  );

                                return (
                                  <tr
                                    key={trip.id}
                                    style={{ borderBottom: "1px solid #eee" }}
                                  >
                                    <td style={{ padding: "12px" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <span>{trip.route}</span>
                                        {isIntraCity && (
                                          <span
                                            className={less.intraTag}
                                            title={`${trip.fromCity?.name || "N/A"
                                              } - ${trip.toCity?.name || "N/A"}`}
                                          >
                                            <img
                                              src={intraIcon}
                                              alt="Intra"
                                              className={less.tagIcon}
                                            />
                                            Intra
                                          </span>
                                        )}
                                        {isEdited && (
                                          <span
                                            className={less.editedTag}
                                            title="This trip has been edited"
                                          >
                                            <img
                                              src={editedIcon}
                                              alt="Edited"
                                              className={less.tagIcon}
                                            />
                                            Edited
                                          </span>
                                        )}
                                      </div>
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      {trip.startTimeFormatted}
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      {trip.tripId}
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      {trip.assetType}
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      ₹{trip.amount}
                                    </td>
                                    <td
                                      style={{
                                        padding: "12px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          this.removeTripFromGrouped(trip.id)
                                        }
                                        style={{
                                          width: "32px",
                                          height: "32px",
                                          borderRadius: "50%",
                                          border: "none",
                                          backgroundColor: "#F59815",
                                          color: "white",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "16px",
                                        }}
                                      >
                                        −
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        )}
                        {groupedTrips.length === 0 && (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "40px",
                              color: "#666",
                              fontSize: "16px",
                            }}
                          >
                            No trips in this group
                          </div>
                        )}
                      </div>
                    )}

                    {activeTab === "available" && (
                      <div>
                        {isMobile ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                            }}
                          >
                            {availableTrips.map((trip) => {
                              return (
                                <div
                                  key={trip.id}
                                  style={{
                                    border: "1px solid #f1f1f1",
                                    borderRadius: "12px",
                                    padding: "16px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      color: "#292929",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {trip.route}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "14px",
                                      color: "#666",
                                      marginBottom: "8px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    {trip.startTime ? (
                                      <span>
                                        {moment(trip.startTime).format(
                                          "hh:mm A"
                                        )}
                                      </span>
                                    ) : (
                                      <span>Unknown</span>
                                    )}
                                    <span style={{ color: "#999" }}>•</span>
                                    {trip.startTime ? (
                                      <span>
                                        {moment(trip.startTime).format(
                                          "MMM D, YYYY"
                                        )}
                                      </span>
                                    ) : (
                                      <span>Unknown</span>
                                    )}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#999",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {trip.assetType}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#999",
                                      marginBottom: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        padding: "2px 6px",
                                        borderRadius: "4px",
                                        fontSize: "10px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Trip ID
                                    </span>
                                    <span>{trip.tripId}</span>
                                  </div>

                                  <button
                                    onClick={() =>
                                      this.addTripToGrouped(trip.id)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: "12px",
                                      border: "none",
                                      borderRadius: "8px",
                                      backgroundColor: "#69AC39",
                                      color: "white",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <img
                                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/Manage.svg"
                                      alt="add"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                    Add
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: "14px",
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#292929" }}>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Route
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Start Time & Date
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Trip ID
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Asset Type
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "left",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Amount
                                </th>
                                <th
                                  style={{
                                    padding: "12px",
                                    textAlign: "center",
                                    borderBottom: "1px solid #ddd",
                                    color: "white",
                                  }}
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {availableTrips.map((trip) => (
                                <tr
                                  key={trip.id}
                                  style={{ borderBottom: "1px solid #eee" }}
                                >
                                  <td style={{ padding: "12px" }}>
                                    {trip.route}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    {trip.startTimeFormatted}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    {trip.tripId}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    {trip.assetType}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    ₹{trip.amount}
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() =>
                                        this.addTripToGrouped(trip.id)
                                      }
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        border: "none",
                                        backgroundColor: "#69AC39",
                                        color: "white",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "16px",
                                      }}
                                    >
                                      +
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                        {availableTrips.length === 0 && (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "40px",
                              color: "#666",
                              fontSize: "16px",
                            }}
                          >
                            No available trips
                          </div>
                        )}
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: isMobile ? "16px" : "24px",
                        paddingTop: isMobile ? "16px" : "20px",
                        borderTop: "1px solid #eee",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? "12px" : "0",
                      }}
                    >
                      <div
                        style={{
                          fontSize: isMobile ? "12px" : "14px",
                          color: "#666",
                          fontWeight: "500",
                          textAlign: isMobile ? "center" : "left",
                        }}
                      >
                        {actionMessage}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: isMobile ? "8px" : "12px",
                          flexDirection: isMobile ? "column" : "row",
                          width: isMobile ? "100%" : "auto",
                        }}
                      >
                        <button
                          onClick={this.closeManageModal}
                          style={{
                            width: isMobile ? "100%" : "200px",
                            padding: isMobile ? "14px 24px" : "12px 24px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            backgroundColor: "white",
                            color: "#666",
                            cursor: "pointer",
                            fontSize: isMobile ? "16px" : "14px",
                            fontWeight: "500",
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={this.handleUpdateTripsFromManage}
                          disabled={!hasChanges || updateTripsLoading}
                          style={{
                            width: isMobile ? "100%" : "200px",
                            padding: isMobile ? "14px 24px" : "12px 24px",
                            border: "none",
                            borderRadius: "8px",
                            backgroundColor:
                              !hasChanges || updateTripsLoading
                                ? "#ccc"
                                : "#7B2AFF",
                            color: "white",
                            cursor:
                              !hasChanges || updateTripsLoading
                                ? "not-allowed"
                                : "pointer",
                            fontSize: isMobile ? "16px" : "14px",
                            fontWeight: "500",
                            opacity:
                              !hasChanges || updateTripsLoading ? 0.6 : 1,
                          }}
                        >
                          {updateTripsLoading ? "Updating..." : "Update"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          {showTripsModal && (
            <>
              <div
                className={less.mobileFilterOverlay}
                onClick={this.closeTripsModal}
              ></div>

              <div className={less.mobileFilterPopup}>
                <div
                  className={less.mobileFilterHandle}
                  onClick={this.closeTripsModal}
                ></div>

                <div className={less.mobileFilterHeader}>
                  <div className={less.mobileFilterTitle}>All Trips</div>
                  <div
                    className={less.mobileFilterClose}
                    onClick={this.closeTripsModal}
                  >
                    ×
                  </div>
                </div>

                <div className={less.mobileFilterContent}>
                  {selectedTripsData.map((trip, index) => (
                    <div key={trip.id} className={less.tripCard}>
                      <div className={less.tripCardHeader}>
                        <span className={less.tripRoute}>{trip.route}</span>
                        <span className={less.tripAmount}>₹{trip.amount}</span>
                      </div>
                      <div className={less.tripCardDetails}>
                        <div
                          className={`${less.tripDetailRow} ${less.tripDetailRowLeft}`}
                        >
                          <span
                            className={less.tripDetailValue}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {trip.startTime !== "N/A" &&
                              trip.startDate !== "N/A" ? (
                              <>
                                <span>{trip.startTime}</span>
                                <span
                                  style={{
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "11px",
                                    background: "#c2c2c2",
                                  }}
                                ></span>
                                <span>{trip.startDate}</span>
                              </>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>
                        <div
                          className={`${less.tripDetailRow} ${less.tripDetailRowLeft}`}
                        >
                          <span className={less.tripDetailValue}>
                            {trip.assetType}
                          </span>
                        </div>
                        <div className={less.tripDetailRow}>
                          <span className={less.tripDetailLabel}>Trip ID:</span>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flex: 1,
                            }}
                          >
                            <span className={less.tripDetailValue}>
                              {trip.tripId}
                            </span>
                            {(trip.isIntraCity ||
                              (trip.lastModifiedOn &&
                                selectedInvoiceForTrips?.lastRejectedOn &&
                                trip.lastModifiedOn >
                                selectedInvoiceForTrips.lastRejectedOn)) && (
                                <span className={less.tripTags}>
                                  {trip.isIntraCity && (
                                    <span
                                      className={less.intraTag}
                                      title={`${trip.fromCity?.name || "N/A"} - ${trip.toCity?.name || "N/A"
                                        }`}
                                    >
                                      <img
                                        src={intraIcon}
                                        alt="Intra"
                                        className={less.tagIcon}
                                      />
                                      Intra
                                    </span>
                                  )}
                                  {trip.lastModifiedOn &&
                                    selectedInvoiceForTrips?.lastRejectedOn &&
                                    trip.lastModifiedOn >
                                    selectedInvoiceForTrips.lastRejectedOn && (
                                      <span
                                        className={less.editedTag}
                                        title="This trip has been edited"
                                      >
                                        <img
                                          src={editedIcon}
                                          alt="Edited"
                                          className={less.tagIcon}
                                        />
                                        Edited
                                      </span>
                                    )}
                                </span>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {showPdfModal && pdfData && (
            <>
              <div
                className={less.mobileFilterOverlay}
                onClick={this.closePdfModal}
              ></div>

              <div className={less.mobilePdfPopup}>
                <div
                  className={less.mobileFilterHandle}
                  onClick={this.closePdfModal}
                ></div>

                <div className={less.mobileFilterHeader}>
                  <div className={less.mobileFilterTitle}>Invoice PDF</div>
                  <div
                    className={less.mobileFilterClose}
                    onClick={this.closePdfModal}
                  >
                    ×
                  </div>
                </div>

                <div
                  style={{
                    padding: "0 24px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <object
                    data={`${pdfData}#toolbar=0&navpanes=0&scrollbar=0`}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "none", borderRadius: "8px", flex: 1 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f9f9f9",
                        padding: "20px",
                        borderRadius: "8px",
                      }}
                    >
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#7B2AFF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginBottom: "20px" }}
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      <p
                        style={{
                          marginBottom: "20px",
                          textAlign: "center",
                          color: "#666",
                        }}
                      >
                        Your invoice is ready!
                      </p>
                    </div>
                  </object>

                  <div
                    style={{
                      padding: "16px 0",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href="#"
                      onClick={this.handleActualDownload}
                      style={{
                        backgroundColor: isDownloadingPdf
                          ? "#9B7AFF"
                          : "#7B2AFF",
                        color: "white",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        textDecoration: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: isDownloadingPdf ? "not-allowed" : "pointer",
                        display: "inline-block",
                        opacity: isDownloadingPdf ? 0.7 : 1,
                        pointerEvents: isDownloadingPdf ? "none" : "auto",
                      }}
                    >
                      {isDownloadingPdf ? "Downloading..." : "Download PDF"}
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}
          {showEditInvoiceModal && resubmitInvoice ? (
            <Modal
              open={showEditInvoiceModal}
              footer={null}
              onCancel={() => {
                this.setState({
                  showEditInvoiceModal: false,
                  resubmitInvoice: null,
                });
              }}
            >
              <div className={less.createInvoiceModal}>
                <span>Edit Invoice Details ?</span>
                <span>Please enter invoice details to continue.</span>
                <div>
                  <span>Invoice Number *</span>
                  <input
                    type="text"
                    value={resubmitInvoice.invoiceNumber}
                    onChange={(e) =>
                      this.setState({
                        resubmitInvoice: {
                          ...resubmitInvoice,
                          invoiceNumber: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={less.btnWrapper}>
                  <button
                    onClick={() => {
                      this.setState({
                        showEditInvoiceModal: false,
                        resubmitInvoice: null,
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button onClick={this.handleEditInvoice}>Create</button>
                </div>
              </div>
            </Modal>
          ) : null}
        </>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={active} isMobile={false} />
          <div class="container">
            <div className={less.header}>
              <div>
                <span>Submitted Invoices</span>
                <span>View complete details of your submitted invoices</span>
              </div>
              <div>
                <Select
                  style={{ width: "50%" }}
                  placeholder="Choose Status"
                  onChange={(value) =>
                    this.handleChange("selectedStatus", value)
                  }
                >
                  <Select.Option value="">All</Select.Option>
                  <Select.Option value="PENDING">Pending</Select.Option>
                  <Select.Option value="APPROVED">Approved</Select.Option>
                  <Select.Option value="REJECTED">Rejected</Select.Option>
                </Select>
                <RangePicker
                  onChange={this.onRangeChange}
                  format="DD/MM/YYYY"
                  value={
                    this.state.currentDateRange
                      ? this.state.currentDateRange.dates
                      : [
                        dayjs().startOf("week").add(1, "day"),
                        dayjs().endOf("day"),
                      ]
                  }
                  disabledDate={(current) =>
                    current && current.isAfter(dayjs(), "day")
                  }
                />
                <button
                  onClick={this.applyDateFilter}
                  disabled={filterApplyLoading}
                  style={{
                    backgroundColor: filterApplyLoading ? "#ccc" : "#7B2AFF",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: filterApplyLoading ? "not-allowed" : "pointer",
                    opacity: filterApplyLoading ? 0.6 : 1,
                  }}
                >
                  {filterApplyLoading ? "Applying..." : "Apply"}
                </button>
              </div>
            </div>
            <div className={less.body}>
              {invoices.length > 0 ? (
                invoices.map((invoice, index) => {
                  const displayTrips = this.getDisplayTripsForInvoice(invoice);
                  return (
                    <div key={invoice._id} className={less.row}>
                      <div className={less.tableWrapper}>
                        <div
                          style={{ paddingTop: "10px", paddingBottom: "10px" }}
                        >
                          <span>Invoice Number: {invoice.invoiceNumber}</span>
                          <div
                            className={
                              invoice.status === "REJECTED"
                                ? less.rejected
                                : invoice.status === "APPROVED"
                                  ? less.confirmed
                                  : less.pending
                            }
                          >
                            <div></div>
                            <span>{invoice.status}</span>
                          </div>
                        </div>
                        <img
                          src={
                            expandedInvoices[invoice._id]
                              ? "https://d1flzashw70bti.cloudfront.net/original/images/header/dropDown/downArrow.svg"
                              : "https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/arrowup.svg"
                          }
                          alt="show more"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.toggleInvoiceExpansion(invoice._id)
                          }
                        />
                      </div>
                      <div className={less.expandable}>
                        {expandedInvoices[invoice._id] ? (
                          <div>
                            {displayTrips.length > 0 && (
                              <div
                                style={{
                                  width: "100%",
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                }}
                              >
                                <table
                                  style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    tableLayout: "auto",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          padding: "10px",
                                          paddingLeft: "20px",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Route
                                      </th>
                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Start Time & Date
                                      </th>

                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Trip Id
                                      </th>
                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Asset Type
                                      </th>

                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {displayTrips.map((tripGroup) => {
                                      const isIntraCity = tripGroup.isIntraCity;
                                      const isEdited =
                                        tripGroup.lastModifiedOn >
                                        Math.max(
                                          invoice.lastRejectedOn,
                                          tripGroup.attachedOnInvoiceAt
                                        );

                                      return (
                                        <tr key={tripGroup._id}>
                                          <td
                                            style={{
                                              padding: "10px",
                                              paddingLeft: "20px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                flexWrap: "nowrap", // keep route + tag on the same line
                                                overflow: "hidden",
                                              }}
                                            >
                                              <span>
                                                {tripGroup.fromCity?.name ||
                                                  "N/A"}{" "}
                                                -{" "}
                                                {tripGroup.toCity?.name ||
                                                  "N/A"}
                                              </span>

                                              {isIntraCity && (
                                                <span
                                                  className={less.intraTag}
                                                  title={`${tripGroup.fromCity?.name ||
                                                    "N/A"
                                                    } - ${tripGroup.toCity?.name ||
                                                    "N/A"
                                                    }`}
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    verticalAlign: "middle",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <img
                                                    src={intraIcon}
                                                    alt="Intra"
                                                    className={less.tagIcon}
                                                    style={{
                                                      width: "14px",
                                                      height: "14px",
                                                    }}
                                                  />
                                                  Intra
                                                </span>
                                              )}

                                              {isEdited && (
                                                <span
                                                  className={less.editedTag}
                                                  title="This trip has been edited"
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    verticalAlign: "middle",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <img
                                                    src={editedIcon}
                                                    alt="Edited"
                                                    className={less.tagIcon}
                                                    style={{
                                                      width: "14px",
                                                      height: "14px",
                                                    }}
                                                  />
                                                  Edited
                                                </span>
                                              )}
                                            </div>
                                          </td>

                                          <td
                                            style={{
                                              padding: "10px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {tripGroup.startTime
                                              ? moment(
                                                tripGroup.startTime
                                              ).format("h:mm A  DD-MM-YYYY")
                                              : "N/A"}
                                          </td>

                                          <td
                                            style={{
                                              padding: "10px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {tripGroup.groupCode || "N/A"}
                                          </td>

                                          <td
                                            style={{
                                              padding: "10px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {tripGroup.assetType || "N/A"}
                                          </td>

                                          <td
                                            style={{
                                              padding: "10px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            ₹{tripGroup.supplyCost || 0}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            )}

                            {locallyModifiedTrips[invoice._id] && (
                              <div
                                className={`${less.localChangesBanner} ${less.localChangesBannerCard}`}
                              >
                                <span className={less.localChangesBannerText}>
                                  This invoice group has unsaved changes. Click
                                  Resubmit to submit the invoice.
                                </span>
                              </div>
                            )}

                            <div className={less.bottomOptions}>
                              <div>
                                <span>
                                  Number of Trips: <b>{displayTrips.length}</b>
                                </span>
                                <span>
                                  Total Amount:{" "}
                                  <b>
                                    ₹
                                    {displayTrips.reduce(
                                      (total, group) =>
                                        total + (group.supplyCost || 0),
                                      0
                                    )}
                                  </b>
                                </span>
                              </div>

                              <div>
                                {invoice.status === "APPROVED" ||
                                  invoice.status === "PENDING" ? (
                                  <button
                                    onClick={() =>
                                      this.handleDownloadInvoice(invoice)
                                    }
                                    disabled={downloadLoading[invoice._id]}
                                    style={{
                                      cursor: downloadLoading[invoice._id]
                                        ? "not-allowed"
                                        : "pointer",
                                      opacity: downloadLoading[invoice._id]
                                        ? 0.6
                                        : 1,
                                    }}
                                  >
                                    {downloadLoading[invoice._id]
                                      ? "Generating..."
                                      : "Download"}
                                    <img src={downloadIcon} alt="download" />
                                  </button>
                                ) : (
                                  <>
                                    {invoice.status === "REJECTED" && (
                                      <button
                                        className={less.rejectBtn}
                                        onClick={() =>
                                          this.handleResubmitClick(invoice)
                                        }
                                        disabled={resubmitLoading[invoice._id]}
                                        style={{
                                          opacity: resubmitLoading[invoice._id]
                                            ? 0.6
                                            : 1,
                                          cursor: resubmitLoading[invoice._id]
                                            ? "not-allowed"
                                            : "pointer",
                                        }}
                                      >
                                        {resubmitLoading[invoice._id]
                                          ? "Resubmitting..."
                                          : "Resubmit"}{" "}
                                        <img
                                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/resubmit.svg"
                                          alt="resubmit"
                                        />
                                      </button>
                                    )}

                                    <button
                                      onClick={() =>
                                        this.handleRemarkClick(invoice)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      Remark{" "}
                                      <img src={remarkIcon} alt="remark" />
                                    </button>
                                    <button
                                      onClick={() =>
                                        this.handleManageClick(invoice)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      Manage{" "}
                                      <img
                                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/lastMile/ungroup.svg"
                                        alt="manage"
                                      />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className={less.noData}>No Invoices Found</div>
              )}
            </div>
          </div>

          {showRemarkModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "340px",
                  maxHeight: "80vh",
                  overflow: "auto",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div
                  style={{
                    padding: "24px 24px 0 24px",
                    textAlign: "center",
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Remark
                </div>

                <div
                  style={{
                    padding: "24px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "20px",
                      lineHeight: "1.5",
                      margin: 0,
                      marginBottom: "24px",
                      color: "#333",
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {selectedInvoiceComment}
                  </div>

                  <button
                    onClick={this.closeRemarkModal}
                    style={{
                      width: "100%",
                      height: "48px",
                      backgroundColor: "#F1E9FF",
                      color: "#7B2AFF",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "16px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#E6D9FF")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#F1E9FF")
                    }
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {showManageModal && selectedInvoice && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "800px",
                  maxHeight: "80vh",
                  overflow: "auto",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div
                  style={{
                    padding: "24px 24px 16px 24px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <div
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Manage Trips in Invoice
                  </div>
                  <button
                    onClick={this.closeManageModal}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "24px",
                      cursor: "pointer",
                      color: "#666",
                      padding: "4px",
                      borderRadius: "4px",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "transparent")
                    }
                  >
                    ×
                  </button>
                </div>

                <div
                  style={{
                    padding: "16px 24px",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  <div>Invoice Number: {selectedInvoice.invoiceNumber}</div>
                  <div>{groupedTrips.length} trips currently grouped</div>
                </div>

                <div
                  style={{
                    height: "1px",
                    backgroundColor: "#eee",
                    margin: "0 24px",
                  }}
                ></div>

                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid #eee",
                    marginBottom: "20px",
                    justifyContent: "flex-start",
                  }}
                >
                  <button
                    onClick={() => this.switchTab("grouped")}
                    style={{
                      padding: "12px 24px",
                      border: "none",
                      backgroundColor: "transparent",
                      color: "#666",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginRight: "0",
                      borderBottom:
                        activeTab === "grouped"
                          ? "3px solid #7B2AFF"
                          : "3px solid transparent",
                    }}
                  >
                    Grouped Trips ({groupedTrips.length})
                  </button>
                  <button
                    onClick={() => this.switchTab("available")}
                    style={{
                      padding: "12px 24px",
                      border: "none",
                      backgroundColor: "transparent",
                      color: "#666",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderBottom:
                        activeTab === "available"
                          ? "3px solid #7B2AFF"
                          : "3px solid transparent",
                    }}
                  >
                    Available Trips ({availableTrips.length})
                  </button>
                </div>

                <div
                  style={{
                    padding: "0 24px 24px 24px",
                  }}
                >
                  {activeTab === "grouped" && (
                    <div>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "14px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f8f9fa" }}>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Route
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Start Time & Date
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Trip ID
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Asset Type
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Amount
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "center",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupedTrips.map((trip) => (
                            <tr
                              key={trip.id}
                              style={{ borderBottom: "1px solid #eee" }}
                            >
                              <td style={{ padding: "12px" }}>{trip.route}</td>
                              <td style={{ padding: "12px" }}>
                                {trip.startTimeFormatted}
                              </td>
                              <td style={{ padding: "12px" }}>{trip.tripId}</td>
                              <td style={{ padding: "12px" }}>
                                {trip.assetType}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹{trip.amount}
                              </td>
                              <td
                                style={{ padding: "12px", textAlign: "center" }}
                              >
                                <button
                                  onClick={() =>
                                    this.removeTripFromGrouped(trip.id)
                                  }
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#F59815",
                                    color: "white",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "16px",
                                  }}
                                >
                                  −
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {groupedTrips.length === 0 && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#666",
                            fontSize: "16px",
                          }}
                        >
                          No trips in this group
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "available" && (
                    <div>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "14px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f8f9fa" }}>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Route
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Start Time & Date
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Trip ID
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Asset Type
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Amount
                            </th>
                            <th
                              style={{
                                padding: "12px",
                                textAlign: "center",
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {availableTrips.map((trip) => (
                            <tr
                              key={trip.id}
                              style={{ borderBottom: "1px solid #eee" }}
                            >
                              <td style={{ padding: "12px" }}>{trip.route}</td>
                              <td style={{ padding: "12px" }}>
                                {trip.startTimeFormatted}
                              </td>
                              <td style={{ padding: "12px" }}>{trip.tripId}</td>
                              <td style={{ padding: "12px" }}>
                                {trip.assetType}
                              </td>
                              <td style={{ padding: "12px" }}>
                                ₹{trip.amount}
                              </td>
                              <td
                                style={{ padding: "12px", textAlign: "center" }}
                              >
                                <button
                                  onClick={() => this.addTripToGrouped(trip.id)}
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#69AC39",
                                    color: "white",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "16px",
                                  }}
                                >
                                  +
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {availableTrips.length === 0 && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#666",
                            fontSize: "16px",
                          }}
                        >
                          No available trips
                        </div>
                      )}
                    </div>
                  )}

                  {hasChanges && (
                    <div
                      className={`${less.localChangesBanner} ${less.localChangesBannerModal}`}
                    >
                      <span className={less.localChangesBannerText}>
                        Clicking Update saves changes locally. Click Resubmit to
                        confirm submission.
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: hasChanges ? "0" : "24px",
                      paddingTop: "20px",
                      borderTop: "1px solid #eee",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#666",
                        fontWeight: "500",
                      }}
                    >
                      {actionMessage}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                      }}
                    >
                      <button
                        onClick={this.closeManageModal}
                        style={{
                          width: "200px",
                          padding: "12px 24px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#666",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={this.handleUpdateTripsFromManage}
                        disabled={!hasChanges || updateTripsLoading}
                        style={{
                          width: "200px",
                          padding: "12px 24px",
                          border: "none",
                          borderRadius: "8px",
                          backgroundColor:
                            !hasChanges || updateTripsLoading
                              ? "#ccc"
                              : "#7B2AFF",
                          color: "white",
                          cursor:
                            !hasChanges || updateTripsLoading
                              ? "not-allowed"
                              : "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                          opacity: !hasChanges || updateTripsLoading ? 0.6 : 1,
                        }}
                      >
                        {updateTripsLoading ? "Updating..." : "Update"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showPdfModal && pdfData && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: "90%",
                  maxWidth: "1000px",
                  height: "90vh",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <div
                  style={{
                    padding: "24px 24px 0 24px",
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f1f1f1",
                  }}
                >
                  <span>Invoice PDF</span>
                  <button
                    onClick={this.closePdfModal}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "24px",
                      cursor: "pointer",
                      color: "#666",
                    }}
                  >
                    ×
                  </button>
                </div>

                <div
                  style={{
                    flex: 1,
                    padding: "24px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <object
                    data={`${pdfData}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    style={{ border: "none", borderRadius: "8px", flex: 1 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f9f9f9",
                        padding: "20px",
                        borderRadius: "8px",
                      }}
                    >
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#7B2AFF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginBottom: "20px" }}
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      <p
                        style={{
                          marginBottom: "20px",
                          textAlign: "center",
                          color: "#666",
                        }}
                      >
                        PDF preview not available in this browser. Please
                        download to view.
                      </p>
                    </div>
                  </object>

                  <div
                    style={{
                      padding: "16px 0",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href="#"
                      onClick={this.handleActualDownload}
                      style={{
                        backgroundColor: isDownloadingPdf
                          ? "#9B7AFF"
                          : "#7B2AFF",
                        color: "white",
                        padding: "12px 24px",
                        borderRadius: "8px",
                        textDecoration: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: isDownloadingPdf ? "not-allowed" : "pointer",
                        display: "inline-block",
                        opacity: isDownloadingPdf ? 0.7 : 1,
                        pointerEvents: isDownloadingPdf ? "none" : "auto",
                      }}
                    >
                      {isDownloadingPdf ? "Downloading..." : "Download PDF"}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showEditInvoiceModal && resubmitInvoice ? (
            <Modal
              open={showEditInvoiceModal}
              footer={null}
              onCancel={() => {
                this.setState({
                  showEditInvoiceModal: false,
                  resubmitInvoice: null,
                });
              }}
            >
              <div className={less.createInvoiceModal}>
                <span>Edit Invoice Details ?</span>
                <span>Please enter invoice details to continue.</span>
                <div>
                  <span>Invoice Number *</span>
                  <input
                    type="text"
                    value={resubmitInvoice.invoiceNumber}
                    onChange={(e) =>
                      this.setState({
                        resubmitInvoice: {
                          ...resubmitInvoice,
                          invoiceNumber: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div className={less.btnWrapper}>
                  <button
                    onClick={() => {
                      this.setState({
                        showEditInvoiceModal: false,
                        resubmitInvoice: null,
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button onClick={this.handleEditInvoice}>Create</button>
                </div>
              </div>
            </Modal>
          ) : null}
        </div>
      );
    }
  }
}

export default buses;
